// 202605 GARPER: filtra imágenes por color manteniendo slider en desktop y móvil
/*
  Filtro de imágenes por color
  - Desktop: slider
  - Mobile: slider
  - Solo muestra imágenes cuyo data-media-color coincide con el color seleccionado
*/

// 202605 GARPER: filtro de imágenes por color reconstruyendo slider

(function () {
  let originalSlides = [];
  let originalThumbs = [];
  let initialized = false;

  function normalizeGarperColor(value) {
    return (value || '').trim().toLowerCase();
  }

  function getGarperSelectedColor() {
    const checkedColor =
      document.querySelector('input[type="radio"][name="Color"]:checked') ||
      document.querySelector('input[type="radio"][name="color"]:checked');

    return checkedColor ? checkedColor.value : null;
  }

  function getGalleryWrapper() {
    return document.querySelector('#product-gallery');
  }

  function getThumbsWrapper() {
    return document.querySelector('#product-thumbs');
  }

  function initGarperOriginalMedia() {
    if (initialized) return;

    const galleryWrapper = getGalleryWrapper();
    const thumbsWrapper = getThumbsWrapper();

    if (!galleryWrapper) return;

    originalSlides = Array.from(
      galleryWrapper.querySelectorAll('.swiper-slide[data-media-color]')
    );

    if (thumbsWrapper) {
      originalThumbs = Array.from(
        thumbsWrapper.querySelectorAll('.thumbs-list-item[data-media-color]')
      );
    }

    initialized = true;
  }

  function getProductGallerySwiper() {
    const galleryWrapper = getGalleryWrapper();
    if (!galleryWrapper) return null;

    const swiperContainer = galleryWrapper.closest('.swiper');

    if (swiperContainer && swiperContainer.swiper) {
      return swiperContainer.swiper;
    }

    const allSwipers = Array.from(document.querySelectorAll('.swiper'));

    for (const swiperEl of allSwipers) {
      if (swiperEl.contains(galleryWrapper) && swiperEl.swiper) {
        return swiperEl.swiper;
      }
    }

    return null;
  }

  function updateGarperSwipers() {
    setTimeout(() => {
      const galleryWrapper = getGalleryWrapper();
      const thumbsWrapper = getThumbsWrapper();

      if (galleryWrapper) {
        const gallerySwiperEl = galleryWrapper.closest('.swiper');

        if (gallerySwiperEl && gallerySwiperEl.swiper) {
          gallerySwiperEl.swiper.update();
          gallerySwiperEl.swiper.updateSlides();
          gallerySwiperEl.swiper.updateSlidesClasses();
          gallerySwiperEl.swiper.slideTo(0, 0);
        }
      }

      if (thumbsWrapper) {
        const thumbsSwiperEl = thumbsWrapper.closest('.swiper');

        if (thumbsSwiperEl && thumbsSwiperEl.swiper) {
          thumbsSwiperEl.swiper.update();
          thumbsSwiperEl.swiper.updateSlides();
          thumbsSwiperEl.swiper.updateSlidesClasses();
          thumbsSwiperEl.swiper.slideTo(0, 0);
        }
      }
    }, 120);
  }

  function rebuildGalleryByColor(selectedColor) {
    if (!selectedColor) return;

    initGarperOriginalMedia();

    const galleryWrapper = getGalleryWrapper();
    const thumbsWrapper = getThumbsWrapper();

    if (!galleryWrapper || originalSlides.length === 0) return;

    const selected = normalizeGarperColor(selectedColor);

    const matchingSlides = originalSlides.filter((slide) => {
      return normalizeGarperColor(slide.dataset.mediaColor) === selected;
    });

    const matchingThumbs = originalThumbs.filter((thumb) => {
      return normalizeGarperColor(thumb.dataset.mediaColor) === selected;
    });

    galleryWrapper.innerHTML = '';

    matchingSlides.forEach((slide) => {
      galleryWrapper.appendChild(slide);
      slide.setAttribute('aria-hidden', 'false');
    });

    if (thumbsWrapper) {
      thumbsWrapper.innerHTML = '';

      matchingThumbs.forEach((thumb) => {
        thumbsWrapper.appendChild(thumb);
        thumb.setAttribute('aria-hidden', 'false');
      });
    }

    updateGarperSwipers();
  }

  function applyInitialColorFilter() {
    const selectedColor = getGarperSelectedColor();

    if (selectedColor) {
      rebuildGalleryByColor(selectedColor);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(() => {
      applyInitialColorFilter();
    }, 250);
  });

  document.addEventListener('change', function (e) {
    const target = e.target;

    if (
      !target.matches('input[type="radio"][name="Color"]') &&
      !target.matches('input[type="radio"][name="color"]')
    ) {
      return;
    }

    rebuildGalleryByColor(target.value);
  });

  document.addEventListener('click', function (e) {
    const thumb = e.target.closest(
      '#product-thumbs .thumbs-list-item[data-slide-media-id]'
    );

    if (!thumb) return;

    const thumbsWrapper = getThumbsWrapper();
    const swiper = getProductGallerySwiper();

    if (!thumbsWrapper || !swiper) return;

    e.preventDefault();

    const visibleThumbs = Array.from(
      thumbsWrapper.querySelectorAll('.thumbs-list-item[data-slide-media-id]')
    );

    const index = visibleThumbs.indexOf(thumb);

    if (index >= 0) {
      swiper.update();
      swiper.updateSlides();
      swiper.updateSlidesClasses();
      swiper.slideTo(index, 0);
    }
  });

  window.addEventListener('resize', function () {
    clearTimeout(window.__garperColorResizeTimer);

    window.__garperColorResizeTimer = setTimeout(() => {
      applyInitialColorFilter();
    }, 200);
  });
})();


/*=================================================================================*/
/*202604 GARPER:
  Garper - Free shipping dynamic message
  Usa /cart.js para leer el total actual del carrito y actualizar el mensaje
*/

function formatCostaRicaCurrency(amount) {
  return new Intl.NumberFormat('es-CR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
}

function updateFreeShippingMessage(cartTotal) {
  const blocks = document.querySelectorAll('[data-free-shipping]');

  blocks.forEach((block) => {
    const threshold = Number(block.dataset.threshold || 0);
    const textEl = block.querySelector('[data-free-shipping-text]');
    const amountEl = block.querySelector('[data-free-shipping-amount]');

    if (!threshold || !textEl) return;

    const remaining = threshold - cartTotal;

    if (remaining > 0) {
      textEl.innerHTML = `
        Te faltan
        <span class="garper-free-shipping__amount" data-free-shipping-amount>
          ₡${formatCostaRicaCurrency(remaining)}
        </span>
        para obtener el envío gratis
      `;
    } else {
      textEl.textContent = '¡Ya tienes envío gratis!';
    }
  });
}

async function fetchCartAndUpdateFreeShipping() {
  try {
    const response = await fetch('/cart.js', {
      headers: {
        'Accept': 'application/json'
      }
    });

    if (!response.ok) return;

    const cart = await response.json();
    const cartTotal = (cart.total_price || 0) / 100;

    updateFreeShippingMessage(cartTotal);
  } catch (error) {
    console.warn('Garper free shipping update failed:', error);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  fetchCartAndUpdateFreeShipping();
});

/*
  Escucha submits de formularios de producto y vuelve a consultar carrito
  unos ms después para capturar el total actualizado
*/
document.addEventListener('submit', function (event) {
  const form = event.target;

  if (!form.matches('form[action*="/cart/add"]')) return;

  setTimeout(() => {
    fetchCartAndUpdateFreeShipping();
  }, 1200);
});

/*
  Escucha clics típicos de add to cart
  por si el theme usa AJAX y no dispara submit estándar
*/
document.addEventListener('click', function (event) {
  const btn = event.target.closest(
    'button[name="add"], .product-form__submit, [data-add-to-cart], .wt-atc-btn'
  );

  if (!btn) return;

  setTimeout(() => {
    fetchCartAndUpdateFreeShipping();
  }, 1200);
});

/*
  Actualizar envío gratis cuando se elimina un producto
  o cambia la cantidad en carrito / drawer
*/
document.addEventListener('click', function (event) {
  const removeBtn = event.target.closest(
    'cart-remove-button, .wt-cart__item__remove'
  );

  if (!removeBtn) return;

  setTimeout(() => {
    fetchCartAndUpdateFreeShipping();
  }, 800);
});

document.addEventListener('change', function (event) {
  const target = event.target;

  if (
    target.matches('input[name="updates[]"]') ||
    target.matches('.quantity__input') ||
    target.matches('[data-quantity-input]')
  ) {
    setTimeout(() => {
      fetchCartAndUpdateFreeShipping();
    }, 800);
  }
});

/*=================================================================================*/